import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { Typography } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../../theme/palette";

import { validateSection } from "../../../utils/sections";

import { selectedSectionSelector } from "../../../reducers/ownApp/selectors";
import {
  sectionEditSelector,
  sectionsSelector,
} from "../../../reducers/sectionManagement/selectors";
import {
  setSectionAsDefault,
  updateSectionEdit,
  setIsSectionEditValid,
} from "../../../reducers/sectionManagement/thunkActions";

import { SectionManagementModalContent } from "./SectionManagementModalContent";
import { View } from "../../View";

const useStyles = makeStyles({
  container: {
    flex: 1,
    margin: "0.5%",
    padding: "0 0 0.25% 0",
    maxWidth: "100rem",
    maxHeight: "99%",
    backgroundColor: palette.white,
    borderRadius: "0.4rem",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    zIndex: 101,
  },
  hidden: {
    display: "none",
  },
  top: {
    borderRadius: "0.4rem 0.4rem 0rem 0rem",
    backgroundColor: palette.dpdLightGrey,
  },
  title: {
    padding: "1rem 1.6rem",
  },
  bottom: {
    display: "flex",
    marginTop: "0.5rem",
  },
});

export const SectionManagementModal = ({ hidden }) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const sectionEdit = useSelector(sectionEditSelector);
  const selectedSection = useSelector(selectedSectionSelector);
  const sections = useSelector(sectionsSelector);
  const selectedSectionCode = (sectionEdit || selectedSection)?.sectionCode;
  const hasSelectedSection = !!selectedSectionCode;

  const errors = validateSection({
    sectionEdit: sectionEdit || selectedSection,
    sections,
  });
  const isValid = !Object.keys(errors).length;

  useEffect(() => {
    dispatch(setIsSectionEditValid(isValid));
  }, [isValid, dispatch]);

  const onChange = useCallback(
    ({ name, value }) => dispatch(updateSectionEdit({ name, value })),
    [dispatch]
  );

  const onSetAsDefault = useCallback(
    () => dispatch(setSectionAsDefault()),
    [dispatch]
  );

  if (!hasSelectedSection) return null;
  else
    return (
      <View className={clsx(styles.container, hidden && styles.hidden)}>
        <View className={styles.top}>
          <Typography className={styles.title}>
            {!sectionEdit ? "SECTION DETAILS" : "EDIT SECTION"}
          </Typography>
        </View>
        <View className={styles.bottom}>
          <SectionManagementModalContent
            section={sectionEdit || selectedSection}
            onChange={onChange}
            onSetAsDefault={onSetAsDefault}
            disabled={!sectionEdit}
            errors={errors}
          />
        </View>
      </View>
    );
};

export default SectionManagementModal;
